var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEndCall2Icon = function SvgEndCall2Icon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "96px",
    viewBox: "0 0 97 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4525E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3D49",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounselling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.1.23-Telecounsel-/-Queue----disconnected-call---cancel-call",
    transform: "translate(-672, -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/03.Popup/No-subtext-Copy",
    transform: "translate(520, 259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(152.597, 40)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 48,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E2F2FF",
    opacity: 0.200000003,
    cx: 48,
    cy: 48,
    r: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/24px/Fill/41",
    transform: "translate(47.998, 47.998) rotate(135) translate(-47.998, -47.998)translate(32.998, 32.9951)",
    fill: "#FFEFF0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(0, -0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0385166,30.0057718 C22.7311065,30.0057718 20.8945703,29.5326479 18.1444546,27.9961731 C14.8002442,26.1207897 12.2135547,24.389409 8.88742833,21.0719898 C5.68052277,17.8670936 4.1199359,15.7921159 1.93578405,11.8176427 C-0.531684632,7.3301182 -0.111062934,4.97785163 0.359122467,3.97251219 C0.919058358,2.77092728 1.7455666,2.05225358 2.81386534,1.33893812 C3.42065241,0.941380628 4.06278374,0.600584675 4.73211461,0.320872864 C4.79909259,0.292072334 4.86138211,0.264611363 4.91697383,0.239829511 C5.24851482,0.0904686216 5.75084965,-0.135247162 6.38714043,0.105873556 C6.81178081,0.265281143 7.19087616,0.591463892 7.78430104,1.17752119 C9.00129089,2.37776655 10.6643541,5.05085763 11.2778723,6.36362598 C11.6897869,7.24840506 11.9623873,7.83245303 11.963057,8.48749764 C11.963057,9.25439549 11.5772639,9.84581103 11.1090878,10.4841111 C11.0213467,10.6040017 10.9342753,10.7185341 10.8498831,10.8297175 C10.3401807,11.4994973 10.2283274,11.6930636 10.3020032,12.03867 C10.4513641,12.7332316 11.5652079,14.8008418 13.395716,16.6273312 C15.2262241,18.4538207 17.2342239,19.4973376 17.9314646,19.6460287 C18.2918061,19.7230533 18.4893912,19.6065117 19.1806039,19.0787252 C19.2797313,19.0030401 19.3815378,18.9246759 19.4880328,18.8463116 C20.202018,18.3151763 20.7659726,17.9394298 21.5147864,17.9394298 L21.5188051,17.9394298 C22.1705008,17.9394298 22.7284273,18.2220769 23.6527234,18.6882436 C24.858327,19.2964036 27.6117917,20.9380339 28.8194046,22.1563633 C29.4068015,22.7484486 29.7343238,23.1262044 29.8944011,23.550175 C30.1355219,24.1884751 29.9084665,24.6888006 29.7604452,25.0236905 C29.7356633,25.0792822 29.7082024,25.1402322 29.6794018,25.2078799 C29.3974766,25.8760187 29.0546668,26.5167971 28.6553086,27.1221105 C27.9433327,28.1870603 27.2219799,29.0115592 26.0177158,29.5721649 C25.3993233,29.8646646 24.7225572,30.0128431 24.0385166,30.0057718 L24.0385166,30.0057718 Z",
    id: "Path"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEndCall2Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/end-call-2-icon.3bee9950.svg";
export { ForwardRef as ReactComponent };